import { authGet } from "@api/auth/auth";
import { DeploymentUser } from "@types";

export const fetchOrganizationUsers = (
  organizationId: number
): Promise<DeploymentUser[]> => {
  const path = `/api/agent/organizations/${organizationId}/users`;
  return authGet<{ users: DeploymentUser[] }>(path).then(
    (result) => result.users
  );
};
